import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useConvertToPendingPal } from "../../store/useConvertToPendingPal";

import Pharmacy from "./Pharmacy/Pharmacy.vue";
import PatientDme from "./PatientDME/PatientDme.vue";
import PatientSupply from "./PatientSupply/PatientSupply.vue";

export default defineComponent({
    components: {
        Pharmacy,
        PatientDme,
        PatientSupply
    },
    computed: {
        ...mapState(useConvertToPendingPal, ["patientDetails", "patientOptions"])
    }
});
